import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../../utils/api"; 
import AdminAccessRequestTemplate from "./AdminTemplate"; 
import "./UnauthorizedPage.css";

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [admins, setAdmins] = useState([]);

  // Get logged-in user from sessionStorage
  const currentUser = {
    name: sessionStorage.getItem("user_name") || "",
    email: sessionStorage.getItem("user_email") || "",
  };

  const loginUrl = window.location.origin + "/login";

  // Fetch Admins using apiService.fetchData
  useEffect(() => {
    const fetchAdmins = async () => {
  try {
    console.log("Fetching admins from /user/roles...");
    const response = await apiService.fetchData("user/roles");

    console.log("Full API response:", response);

    if (response.status === "success" && response.data) {
      const adminUsers = response.data
        .filter((user) => user.role_name === "Admin")
        .map((admin) => ({
          email: admin.user_email,
          name: admin.user_name,
        }));

      console.log("Filtered Admins (role_name === 'Admin'):", adminUsers);
      console.log(`Total Admins to receive email: ${adminUsers.length}`);

      setAdmins(adminUsers);
    } else {
      console.warn("API response not successful or missing data:", response);
    }
  } catch (error) {
    console.error("Failed to fetch admin users:", error);
  }
};
    fetchAdmins();
  }, []);

  const handleLoginRedirect = () => {
    sessionStorage.clear();
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    navigate("/login", { replace: true });
  };

  // Reuse your existing sendEmail logic (or use apiService if available)
  const sendEmail = async (to, subject, html) => {
    const emailServiceUrl =
      "https://crticketingsystem-backend-dev.icyfield-14eece6f.eastus.azurecontainerapps.io/api/send_email";

    const response = await fetch(emailServiceUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ to, subject, html }),
    });

    if (!response.ok) throw new Error(`Failed to send email to ${to}`);
    return response.json();
  };

  const requestAccess = async () => {
    if (isLoading || admins.length === 0) return;
    console.log("Request Access clicked. Sending emails to admins:", admins);

    setIsLoading(true);

    const subject = `Access Request: ${currentUser.name} Needs CLM Approval`;

    try {
      const emailPromises = admins.map((admin) => {
        const html = AdminAccessRequestTemplate({
          adminName: admin.name,
          requesterName: currentUser.name,
          requesterEmail: currentUser.email,
          loginUrl,
        });

        return sendEmail(admin.email, subject, html);
      });

      await Promise.all(emailPromises);

      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 6000);
    } catch (error) {
      alert("Failed to send access request. Please try again.");
      console.error("Email send error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="unauthorized-wrapper template-5-bg">
      {/* Floating Glass Shapes */}
      <div className="floating-shapes">
        <div className="shape"></div>
        <div className="shape"></div>
      </div>

      {/* Template 1 Card */}
      <div className="card-1">
        <div className="lock-container">
          <div className="lock"></div>
        </div>
        <h1 className="title-1">Access Restricted</h1>
        <p className="message-1">
          We apologize, but you do not currently have authorization to access this application.
          To gain access, please submit a request to the CLM administrator who will review and
          grant the necessary permissions.
        </p>
        <div className="buttons">
          <button
            className={`btn btn-primary ${isLoading ? "loading" : ""}`}
            onClick={requestAccess}
            disabled={isLoading || admins.length === 0}
          >
            {isLoading ? "Sending..." : "Request Access"}
          </button>
          <button className="btn btn-secondary" onClick={handleLoginRedirect}>
            Go to Login
          </button>
        </div>

        {/* Show loading if admins not loaded */}
        {/* {admins.length === 0 && !isLoading && (
          <p style={{ color: "#aaa", fontSize: "14px", marginTop: "10px" }}>
            Loading admin list...
          </p>
        )} */}
      </div>

      {/* Success Popup */}
      {showPopup && (
        <div className="popup-success">
          <p>
             A mail has been sent successfully to the CLM Admin.

            <br />
            They will review and approve your request shortly.
          </p>
          <button onClick={() => setShowPopup(false)} className="popup-close">
            ×
          </button>
        </div>
      )}
    </div>
  );
};

export default UnauthorizedPage;